import { Model } from 'vue-api-query';

export default defineNuxtPlugin({
  name: 'api-query',
  dependsOn: ['http'],
  setup() {
    const { $http } = useNuxtApp();
    Model.$http = $http;
    return {};
  }
});
